import styled, { css } from 'styled-components';

const SwitchStyles = styled.div`
  background: ${props => props.theme.colors.bodyBackground};
  border: 0.0625rem solid ${props => props.theme.colors.inputBorder};
  border-radius: ${props => props.theme.space[2]};
  cursor: pointer;
  position: relative;
  width: 3rem;
  height: 1.5rem;

  &:hover {
    border-color: ${props => props.theme.colors.gray};
  }

  &::before {
    pointer-events: none;
    content: '';
    background: ${props => props.theme.colors.gray};
    position: absolute;
    display: block;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    top: 2px;
    left: 2px;
  }

  ${props =>
    props.isActive === true &&
    css`
      border-color: ${props.theme.colors.primary};
      &::before {
        left: 26px;
        background-color: ${props.theme.colors.primary};
      }
    `};
`;

export default SwitchStyles;
